
// 全局混入方法
let globalMethods = {
  data () {
    return {
      startVideo: require('@/assets/video/intro.mp4'),
      endVideo: require('@/assets/video/outro.mp4')
    }
  },
  methods: {
    index2ABC (array) {
      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      array.forEach((item, index) => {
        item.index = letters.substr(index, 1)
      })
    },
    ABC2Index (str) {
      let letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      str = str.trim()
      return letters.indexOf(str)
    },
    // 记录当前学习进度  pIndex章节数组下标  cIndex小节数组下标
    setLessonLocation (pIndex, cIndex, finishState = true) {
      // debugger
      console.log('this.$store.state.isScormFlag', this.$store.state.isScormFlag)
      let lessonLocation = this.$store.state.lessonLocation
      if (!lessonLocation) {
        if (localStorage.getItem(this.data.scorm_id + 'lessonLocation')) {
          lessonLocation = localStorage.getItem(this.data.scorm_id + 'lessonLocation')
        } else {
          let lessonArr = []
          this.data.part_list.forEach((item, index) => {
            let str = ''
            item.chapter_list.forEach((itm) => {
              str += '0'
            })
            lessonArr[index] = str
          })
          lessonLocation = lessonArr.join('|') + '||0-0'
          this.$store.commit('lessonLocation', lessonLocation)
          localStorage.setItem(this.data.scorm_id + 'lessonLocation', lessonLocation)
        }
      }
      let progressArr = lessonLocation.split('||')[0].split('|')
      let curruntPartAllChapter = progressArr[pIndex].split('')
      if (finishState) curruntPartAllChapter[cIndex] = '1'
      let curruntPartAllChapterStr = curruntPartAllChapter.join('')
      progressArr[pIndex] = curruntPartAllChapterStr
      let totalPartAllChapterStr = progressArr.join('|') + '||' + pIndex + '-' + cIndex
      this.$store.commit('lessonLocation', totalPartAllChapterStr)
      localStorage.setItem(this.data.scorm_id + 'lessonLocation', totalPartAllChapterStr)
      this.setProgressLength()
      // 提交scorm
      if (this.$store.state.isScormFlag) {
        doLMSSetValue('cmi.core.lesson_location', totalPartAllChapterStr)
        let scromCompleted = true
        for (let item of progressArr) {
          if (item.includes('0')) {
            scromCompleted = false
            break
          }
        }
        // 是否完成所有小节
        if (scromCompleted) {
          doLMSSetValue('cmi.core.lesson_status', 'completed')
        }
        if (this.$global_config.lesson.compute_time === 1) {
          computeTime()
          console.log('执行了切换小节更新学时 computeTime()')
        }
        doLMSCommit()
        console.log('已经执行了doLMSCommit函数............')
        console.log('=====================================设置了小节完成进度', doLMSGetValue('cmi.core.lesson_location'))
      }
    },
    // 读取当前学习进度
    getLessonLocation () {
      // debugger
      const scormId = this.data.scorm_id
      let lessonLocation
      if (this.$store.state.isScormFlag) { // scorm协议课件
        lessonLocation = doLMSGetValue('cmi.core.lesson_location')
        if (lessonLocation.indexOf('||') < 0) {
          let userId = doLMSGetValue('cmi.core.student_id')
          localStorage.removeItem(userId + '-' + scormId)
          let lessonArr = []
          this.data.part_list.forEach((item, index) => {
            let str = ''
            item.chapter_list.forEach((itm) => {
              str += '0'
            })
            lessonArr[index] = str
            lessonLocation = lessonArr.join('|') + '||0-0'
          })
        }
        // saveData = doLMSGetValue('cmi.suspend_data')
        console.log('==================================获取小节的完成进度', lessonLocation)
        console.log('==================================core的所有属性', doLMSGetValue('cmi.core._children'))
      } else { // 非scrom课件
        lessonLocation = localStorage.getItem(scormId + 'lessonLocation')
      }
      let progressArr = lessonLocation.split('||')[0].split('|')
      if (progressArr.length !== this.data.part_list.length) {
        console.log('检测到平台数据与课件包数据不匹配，重新初始化')
        let lessonArr = []
        this.data.part_list.forEach((item, index) => {
          let str = ''
          item.chapter_list.forEach((itm) => {
            str += '0'
          })
          lessonArr[index] = str
          lessonLocation = lessonArr.join('|') + '||0-0'
        })
      }
      this.$store.commit('lessonLocation', lessonLocation)
      if (lessonLocation) {
        this.data.part_list.map((li, index) => {
          if (progressArr[index] && li.chapter_list.length !== progressArr[index].length) {
            this.$layer.msg('小节数据不匹配')
          }
          li.chapter_list.map((item, ind) => {
            item.is_finished = progressArr[index] ? progressArr[index][ind] : 0
            return item
          })
          return li
        })
        // 如果当前章节是片头或片尾退出
        if (this.$store.state.cur_data.chapter_type == -1 || this.$store.state.cur_data.chapter_type == -2) return
        let currentChapter = lessonLocation.split('||')[1]
        let pIndex = Number(currentChapter.split('-')[0])
        let cIndex = Number(currentChapter.split('-')[1])
        this.$store.commit('currentChapterIndex', cIndex)// 保存当前小节数组下标
        this.$store.commit('currentPartIndex', pIndex)// 保存当前章节数组下标
        this.$store.commit('cur_data', this.data.part_list[pIndex].chapter_list[cIndex])// 保存当前小节数组对象

        let next_data
        if (cIndex < this.data.part_list[pIndex].chapter_list.length - 1) {
          next_data = this.data.part_list[pIndex].chapter_list[cIndex + 1]
        } else if (pIndex < this.data.part_list.length - 1) {
          next_data = this.data.part_list[pIndex + 1].chapter_list[0]
        } else {
          next_data = this.data.part_list[pIndex].chapter_list[cIndex]
        }
        this.$store.commit('next_data', next_data)
      };
    },
    setChaperAnswer (data) {
      const cIndex = this.$store.state.currentChapterIndex
      const pIndex = this.$store.state.currentPartIndex
      const scormId = this.data.scorm_id
      // 保存数据
      let chapterId = this.data.part_list[pIndex].chapter_list[cIndex].chapter_id
      let quiz_type = parseInt(this.data.part_list[pIndex].chapter_list[cIndex].chapter_content.quiz_type)
      let stashData
      if (data) {
        stashData = data
      } else {
        stashData = this.$store.state.cur_data.chapter_content.dry || this.$store.state.currentChapterData.chapter_content.dry // 题干数据
      }
      let commitData, saveData
      switch (quiz_type) {
        case 1:
          commitData = this.setQuiz12Sub(stashData)
          break
        case 2:
          commitData = this.setQuiz12Sub(stashData)
          break
        case 3: // 填空
          commitData = this.getQuiz3Sub(stashData)
          break
        case 4: // 拖拽单选
          commitData = this.setQuiz45Sub(stashData)
          break
        case 5:
          commitData = this.setQuiz45Sub(stashData)
          break
        case 6:
          commitData = this.getQuiz6Sub(stashData)
          break
        case 7:
          commitData = this.getQuiz7Sub(stashData)
          break
        case 8:
          commitData = this.getQuiz8Sub(stashData)
      }
      this.setLessonLocation(pIndex, cIndex)

      if (this.$store.state.isScormFlag) { // scorm协议课件 使用userId+scromId最为缓存key
        let userId = doLMSGetValue('cmi.core.student_id')
        saveData = JSON.parse(localStorage.getItem(userId + '-' + scormId))
        if (commitData.length > 0) {
          if (!saveData) {
            saveData = {}
          }
          saveData[chapterId] = commitData
          localStorage.setItem(userId + '-' + scormId, JSON.stringify(saveData))
        }
        doLMSSetValue('cmi.student_data.mastery_score', JSON.stringify(saveData))
      } else { // 非scrom课件
        saveData = JSON.parse(localStorage.getItem('ceibs' + scormId))
        if (commitData.length > 0) {
          if (!saveData) {
            saveData = {}
          }
          saveData[chapterId] = commitData
          localStorage.setItem('ceibs' + scormId, JSON.stringify(saveData))
        }
      }

      // 保存到scorm对应字段
      // if (this.$store.state.isScormFlag) {
      //   doLMSSetValue('cmi.suspend_data', JSON.stringify(saveData))
      //   doLMSCommit()
      //   console.log('====================================设置了小测验的提交答案', doLMSGetValue('cmi.suspend_data'))
      // }
    },
    getChapterAnswer () {
      // debugger
      // 取答案
      const cIndex = this.$store.state.currentChapterIndex
      const pIndex = this.$store.state.currentPartIndex
      const scormId = this.data.scorm_id
      // 保存数据

      let chapterId = this.data.part_list[pIndex].chapter_list[cIndex].chapter_id

      let quizType
      if (this.data.part_list[pIndex].chapter_list[cIndex].chapter_type == 2) {
        quizType = parseInt(this.data.part_list[pIndex].chapter_list[cIndex].chapter_content.quiz_type)
      }

      let stashData = this.data.part_list[pIndex].chapter_list[cIndex]
      let saveData, answerData
      // if (stashData.answerShow) {
      //   this.setLessonLocation(pIndex, cIndex)
      // }
      if (this.$store.state.isScormFlag) { // scorm协议课件
        // debugger
        let userId = doLMSGetValue('cmi.core.student_id')
        saveData = doLMSGetValue('cmi.student_data.mastery_score') ? doLMSGetValue('cmi.student_data.mastery_score') : JSON.parse(localStorage.getItem(userId + '-' + scormId))
      } else { // 非scrom课件
        saveData = JSON.parse(localStorage.getItem('ceibs' + scormId))
      }

      let lessonLocation
      if (this.$store.state.isScormFlag) { // scorm协议课件
        lessonLocation = doLMSGetValue('cmi.core.lesson_location')
      } else {
        lessonLocation = localStorage.getItem(scormId + 'lessonLocation')
      }
      if (!lessonLocation || lessonLocation.indexOf('||') < 0) {
        let lessonArr = []
        this.data.part_list.forEach((item, index) => {
          let str = ''
          item.chapter_list.forEach((itm) => {
            str += '0'
          })
          lessonArr[index] = str
        })
        lessonLocation = lessonArr.join('|') + '||0-0'
        this.$store.commit('lessonLocation', lessonLocation)
        localStorage.setItem(this.data.scorm_id + 'lessonLocation', lessonLocation)
      }
      let progressArr = lessonLocation.split('||')[0].split('|')
      if (saveData !== null && progressArr[pIndex][cIndex] == 1) {
        answerData = saveData[chapterId] ? saveData[chapterId] : ''
      } else {
        answerData = ''
      }
      switch (quizType) {
        case 1:
          this.getQuiz12Sub(stashData, answerData)
          break
        case 2:
          this.getQuiz12Sub(stashData, answerData)
          break
        case 3:
          this.getQuiz3Sub(stashData, answerData)
          break
        case 4:
          this.getQuiz45Sub(stashData, answerData)
          break
        case 5:
          this.getQuiz45Sub(stashData, answerData)
          break
        case 6:
          this.getQuiz6Sub(stashData, answerData)
          break
        case 7:
          this.getQuiz7Sub(stashData, answerData)
          break
        case 8:
          this.getQuiz8Sub(stashData, answerData)
      }
    },
    setQuiz12Sub (data) {
      let returnData = []
      data.forEach(item => {
        let save = {}
        save.answerStatus = item.answerStatus
        returnData.push(save)
      })
      return returnData
    },
    // 单选/多选
    getQuiz12Sub (data, answerData) {
      let right_arr = []
      // 取答案
      let datas = data.chapter_content.dry[0].option
      datas.forEach((e, i) => {
        // 记录题干对错
        if (answerData === '') {
          this.$set(e, 'answerStatus', 0) // 初始化状态
        } else {
          this.$set(e, 'answerStatus', answerData[i].answerStatus)
          right_arr.push(answerData[i].answerStatus)
        }
      })
      // 判断总答案对错
      if (right_arr.indexOf(3) == -1 && right_arr.indexOf(4) == -1) {
        data.answer_right = true
      } else {
        data.answer_right = false
      }
      if (answerData) {
        data.answerShow = true // 答案显示
      } else {
        data.answerShow = false // 初始化答案不显示
      }
      return data
    },
    // 问答
    getQuiz3Sub (data, answerData) {
      // debugger
      let returnData = []
      if (answerData) {
        // 取答案
        // data.chapter_content.dry[0].answer = answerData[0].answer
        this.$set(data.chapter_content.dry[0], 'answer', answerData[0].answer)
        this.$set(data, 'answerShow', true)// 答案显示
        returnData = data
      } else {
        // 存答案
        if (!data.chapter_id) {
          returnData.push({
            answer: data[0].answer // 内容
          })
        }
      }
      return returnData
    },
    // 拖拽单选/多选存储答案
    setQuiz45Sub (data) {
      // debugger
      let returnData = []
      if (!data.chapter_id) {
        let save
        data.forEach(item => {
          save = {}
          save.chosedItem = []
          save.right_answer = item.right_answer
          if (item.chosedItem.index || item.chosedItem[0].index) {
            item.chosedItem.forEach(e => {
              save.chosedItem.push(e.index)
            })
          } else {
            save.chosedItem = item.chosedItem
          }
          save.answerStatus = item.answerStatus
          returnData.push(save)
        })
        returnData[0].isRight = data[0].isRight // 总答案对错记录在第一个题干里isRight 0 错
      }
      return returnData
    },
    // 拖拽单选/多选
    getQuiz45Sub (data, answerData) {
      // 取答案
      // debugger
      let data_dry = data.chapter_content.dry
      let allChosedItem = []
      data_dry.forEach((e, i) => {
        if (answerData === '') {
          this.$set(e, 'dragAlive', 0)
          this.$set(e, 'chosedItem', [])
          this.$set(e, 'answerStatus', 0)
          this.$set(e, 'chosedItemId', [])
        } else {
          // 获取题干对错
          this.$set(e, 'answerStatus', answerData[i].answerStatus)
          this.$set(e, 'chosedItem', answerData[i].chosedItem)
          this.$set(e, 'right_answer', answerData[i].right_answer)
          allChosedItem = allChosedItem.concat(answerData[i].chosedItem)
        }
      })
      // 获取总答案对错
      if (answerData) {
        data_dry[0].isRight = answerData[0].isRight
        data.answerShow = true // 答案显示
        data.allChosedItem = allChosedItem
      } else {
        data.answerShow = false // 答案显示
      }
    },
    // 多行填空/单行填空
    getQuiz6Sub (data, answerData) {
      // debugger
      let returnData = []
      if (answerData) {
        // 取答案
        data.chapter_content.dry.forEach((e, i) => {
          this.$set(e, 'answer', answerData[i].answer)
        })
        this.$set(data, 'answerShow', true)// 答案显示
        returnData = data
      } else {
        // 存答案
        if (!data.chapter_id) {
          data.forEach(e => {
            let save = {}
            save.answer = e.answer
            returnData.push(save)
          })
        }
      }
      return returnData
    },
    // 段落填空
    getQuiz7Sub (data, answerData) {
      // debugger
      let returnData = []
      if (answerData) {
        // 取答案
        this.$set(data.chapter_content.dry[0], 'answer', answerData)
        this.$set(data, 'answerShow', true)// 答案显示
        returnData = data
      } else {
        // 存答案
        if (!data.chapter_id) {
          returnData = data[0].answer
        }
      }
      return returnData
    },
    // 判断
    getQuiz8Sub (data, answerData) {
      // debugger
      let returnData = []
      if (answerData) {
        // 取答案
        let data_dry = data.chapter_content.dry
        data_dry.forEach((e, i) => {
          // 获取题干对错
          this.$set(e, 'isChosed', answerData[i].isChosed)
          this.$set(e, 'isRight', answerData[i].isRight)
        })
        this.$set(data, 'answerShow', true)// 答案显示
        returnData = data
      } else {
        // 存答案
        if (!data.chapter_id) {
          data.forEach((e, i) => {
            let save = {}
            save.isChosed = e.isChosed
            save.isRight = e.isRight
            returnData.push(save)
          })
        }
      }
      return returnData
    },
    // 设置进度条进度
    setProgressLength () {
      let lessonLocation = this.$store.state.lessonLocation
      let progressArr = lessonLocation.split('||')[0].split('|')
      let allChapterLength = 0
      let finishLength = 0

      progressArr.filter(li => {
        allChapterLength += li.length
        // console.log("完成",li)
        finishLength += this.getStrCount(li, '1')
      })
      this.$store.commit('setStudyProgress', finishLength / allChapterLength)
      if (this.$store.state.isScormFlag && this.$global_config.lesson.scorm_lesson_progress) {
        doLMSSetValue('cmi.core.lesson_progress', Math.round(finishLength / allChapterLength * 100))
      }
    },
    // js 获取指定字符串个数
    getStrCount (scrstr, armstr) { // scrstr 源字符串 armstr 特殊字符
      let count = 0
      while (scrstr.indexOf(armstr) != -1) {
        scrstr = scrstr.replace(armstr, '')
        count++
      }
      return count
    }
  }

}
export default globalMethods
